import { z } from 'zod';

import { FMS_ROUNDING_MODE } from '#/modules/finMgmt/claims/helper/paymentRequestStatus';

const lineSchema = z.object({
  itemName: z.string().trim().min(1, '請填寫品項'),
  purpose: z.string().trim().min(1, '請填寫用途'),
  unitPrice: z.union([z.string(), z.number()]).refine((value) => {
    const n = Number(value);
    return Number.isFinite(n) && n >= 0;
  }, { message: '單價不可為負' }),
  qty: z.union([z.string(), z.number()]).refine((value) => {
    const n = Number(value);
    return Number.isFinite(n) && n >= 1;
  }, { message: '數量須 ≥ 1' }),
});

export const paymentRequestFormSchema = z.object({
  paymentReason: z.string().trim().min(1, '請填寫請款事由'),
  roundingMode: z.enum([
    FMS_ROUNDING_MODE.HALF_UP,
    FMS_ROUNDING_MODE.CEILING,
    FMS_ROUNDING_MODE.FLOOR,
  ], { message: '請選擇進位法' }),
  remark: z.string().optional().nullable(),
  lines: z.array(lineSchema).min(1, '至少一筆明細'),
  voucherIds: z.array(z.string()).min(1, '請選擇至少一張有效憑證'),
});

export const PAYMENT_REQUEST_FIELD_LABELS = {
  paymentReason: '請款事由',
  roundingMode: '進位法',
  remark: '備註',
  lines: '明細',
  voucherIds: '憑證',
  'lines.itemName': '品項',
  'lines.purpose': '用途',
  'lines.unitPrice': '單價',
  'lines.qty': '數量',
};

export function createEmptyPaymentRequestLine() {
  return {
    itemName: '',
    purpose: '',
    unitPrice: '',
    qty: 1,
  };
}

export const PAYMENT_REQUEST_FORM_DEFAULTS = {
  paymentReason: '',
  roundingMode: FMS_ROUNDING_MODE.HALF_UP,
  remark: '',
  lines: [createEmptyPaymentRequestLine()],
  voucherIds: [],
};
